import { BaseModel } from "../base-model";
import { GenericBaseParameter } from "../base-parameter";
//#region list data
export interface IPersonPropertyListingModel {}
export class PersonPropertyListingModel
  extends BaseModel<IPersonPropertyListingModel>
  implements IPersonPropertyListingModel {
  constructor(option?: IPersonPropertyListingModel) {
    super(option);
  }
}

//#endregion

//#region search condition
export interface IPersonPropertyParameterModel {
  PersonId?: number;
}
export class PersonPropertyParameterModel
  extends GenericBaseParameter<IPersonPropertyParameterModel>
  implements IPersonPropertyParameterModel {
  PersonId: number;
  constructor(option?: IPersonPropertyParameterModel) {
    super();
    Object.keys(option).forEach(key => (this[key] = option[key]));
  }
}
//#endregion
